export const SCHEDULED_REPORTS_OPEN_MODAL = "SCHEDULED_REPORTS_OPEN_MODAL";
export const SCHEDULED_REPORTS_CONTACTS_OPEN_MODAL = "SCHEDULED_REPORTS_CONTACTS_OPEN_MODAL";